import { render, staticRenderFns } from "./rule-content.vue?vue&type=template&id=48f4bac2&scoped=true"
import script from "./rule-content.vue?vue&type=script&lang=js"
export * from "./rule-content.vue?vue&type=script&lang=js"
import style0 from "./rule-content.vue?vue&type=style&index=0&id=48f4bac2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f4bac2",
  null
  
)

export default component.exports